/* global axios */
import ApiClient from './ApiClient';

class RelatorioAPI extends ApiClient {
  constructor() {
    super('relatorio', { accountScoped: true });
  }

  // SPEC 42 / P37-20 — relatório mensal operacional congelado.
  relatorioMensal(params = {}) {
    return axios.get(`${this.url}/mensal`, { params });
  }

  relatorioMensalShow(id) {
    return axios.get(`${this.url}/mensal/${id}`);
  }

  gerarRelatorioMensal() {
    return axios.post(`${this.url}/mensal/generate`);
  }

  imoveisMaisProcurados(params = {}) {
    return axios.get(`${this.url}/imoveis_mais_procurados`, { params });
  }

  bairrosMaisProcurados(params = {}) {
    return axios.get(`${this.url}/bairros_mais_procurados`, { params });
  }

  tiposMaisProcurados(params = {}) {
    return axios.get(`${this.url}/tipos_mais_procurados`, { params });
  }

  precoMediano(params = {}) {
    return axios.get(`${this.url}/preco_mediano`, { params });
  }

  leadsPorCanal(params = {}) {
    return axios.get(`${this.url}/leads_por_canal`, { params });
  }

  leadsPorDia(params = {}) {
    return axios.get(`${this.url}/leads_por_dia`, { params });
  }

  leadsPorHorario(params = {}) {
    return axios.get(`${this.url}/leads_por_horario`, { params });
  }

  leadsPorSemana(params = {}) {
    return axios.get(`${this.url}/leads_por_semana`, { params });
  }

  leadsPorMes(params = {}) {
    return axios.get(`${this.url}/leads_por_mes`, { params });
  }

  statusPorCanal(params = {}) {
    return axios.get(`${this.url}/status_por_canal`, { params });
  }

  resumo(params = {}) {
    return axios.get(`${this.url}/resumo`, { params });
  }

  analyticsFunil(params = {}) {
    return axios.get(`${this.url}/analytics_funil`, { params });
  }

  analyticsEventos(params = {}) {
    return axios.get(`${this.url}/analytics_eventos`, { params });
  }

  performanceSetup(params = {}) {
    return axios.get(`${this.url}/performance_setup`, { params });
  }

  exportCsv(params = {}) {
    return axios.get(`${this.url}/export_csv`, {
      params,
      responseType: 'blob',
    });
  }

  exportPdf(params = {}) {
    return axios.get(`${this.url}/export_pdf`, {
      params,
      responseType: 'blob',
    });
  }

  exportXlsx(params = {}) {
    return axios.get(`${this.url}/export_xlsx`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new RelatorioAPI();
